import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BookmarkOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bookmark_outline"}/>
}
